export default {
  siteName: '六合宝典',
  siteDescription: '官方权威指南',
  home: '首页',
  about: '关于我们',
  categories: '内容分类',
  viewAll: '查看全部',
  latestArticles: '最新文章',
  featuredArticles: '精选文章',
  faq: '常见问题',
  contactUs: '联系我们',
  sendMessage: '发送消息',
  submitSuccess: '提交成功',
  submitError: '提交失败',
  backHome: '返回首页',
  notFound: '页面未找到',
  readMore: '阅读更多',
  disclaimer: '本站所有内容仅供信息参考，不构成任何投注建议。',
};